import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from './OrganizationAppResource';
import OrganizationMemberAppResource from './OrganizationMemberAppResource';
import StageAppResource from './StageAppResource';
import WorkspaceStageTypeAppResource from './WorkspaceStageTypeAppResource';
import ResourceAppResource from './ResourceAppResource';
import TaskAppResource from './TaskAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';

export const PLAN = 'plan';
export const SEARCH = 'search';
export const OFFER = 'offer';
export const INSPECT = 'inspect';
export const FINANCE = 'finance';
export const CLOSE = 'close';
export const PREPARE = 'prepare';
export const LIST = 'list';
export const PREPARE_AND_LEARN = 'prepare-and-learn';
export const GET_A_LOAN = 'get-a-loan';
export const APPLY_TO_REFINANCE = 'apply-to-refinance';

export const TYPE = {
    PLAN,
    SEARCH,
    OFFER,
    INSPECT,
    FINANCE,
    CLOSE,
    PREPARE,
    LIST,
    PREPARE_AND_LEARN,
    GET_A_LOAN,
    APPLY_TO_REFINANCE,
};

class StageTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Stage-Type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'stages/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'type',
            'name',
            'organizationUuid',
            'ownerOrganizationMemberUuid',
            'isSystem',
            'meta',
            'workspaceTypes',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            ownerOrganizationMember: OrganizationMemberAppResource,
            workspaces: WorkspaceStageTypeAppResource,
            stages: StageAppResource,
            resources: ResourceAppResource,
            tasks: TaskAppResource,
            workspaceTypes: WorkspaceTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            ownerOrganizationMember: 'owner_organization_member_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
            },
            type: {
                type: 'string',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
            },
            ownerOrganizationMemberUuid: {
                type: 'string',
            },
            isSystem: {
                type: 'boolean',
            },
            meta: {
                type: 'string',
                presence: true,
            },
            workspaceTypes: {},
        };
    }

}

export default StageTypeAppResource;
